/**
 * Format UTC date to Indian Standard Time (IST) in 12-hour format
 * @param dateString - UTC date string or Date object
 * @returns Formatted date string in IST
 */
export function formatDateIST(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'N/A';

  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) return 'N/A';

  // Convert UTC to IST (UTC + 5:30)
  const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
  const istDate = new Date(date.getTime() + istOffset);

  // Format in 12-hour format
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC' // Using UTC with manual offset
  };

  const formatted = istDate.toLocaleString('en-IN', options);

  // Add IST suffix
  return `${formatted} IST`;
}

/**
 * Format date to show only date in Indian format
 * @param dateString - UTC date string or Date object
 * @returns Formatted date string
 */
export function formatDateOnly(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'N/A';

  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) return 'N/A';

  // Convert UTC to IST (UTC + 5:30)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + istOffset);

  return istDate.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  });
}

/**
 * Format time to show only time in IST 12-hour format
 * @param dateString - UTC date string or Date object
 * @returns Formatted time string
 */
export function formatTimeOnly(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'N/A';

  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) return 'N/A';

  // Convert UTC to IST (UTC + 5:30)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + istOffset);

  return istDate.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
  });
}